export function toggleModalAnimation(id: string): void {
    const modal = document.getElementById(`${id}__modal`);
    if(!modal) { return; }

    const content:HTMLDivElement = modal.querySelector('.hds-o-modal__block');
    if(!content) { return;}

    if (modal.classList.contains('hide')) {
        modal.classList.remove('hide');
        document.body.style.position = 'absolute';
        document.body.style.overflow = 'hidden';
        content.style.opacity = '0';
        content.classList.add('slideUp');
        return;
    }
    content.classList.replace('slideUp', 'slideDown');

    setTimeout(() => {
        modal.classList.add('hide');
        document.body.style.position = '';
        document.body.style.overflow = '';
        content.classList.remove('slideDown');
    }, 300);
}

